<template>
  <div v-if="isVisible" class="video-modal" @click.self="handleClose">
    <div class="video-content">
      <span class="video-close" @click="handleClose">×</span>
      <video ref="videoPlayer" :src="videoSrc" controls autoplay></video>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "VideoModal",
  data() {
    return {
      isVisible: false,
      videoSrc: ""
    };
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      } else {
        this.pauseAndReset();
      }
    }
  },
  methods: {
    open(src) {
      this.videoSrc = src || "";
      this.isVisible = true;
    },
    handleClose() {
      this.pauseAndReset();
      this.isVisible = false;
      this.$emit("close");
    },
    pauseAndReset() {
      if (this.$refs.videoPlayer) {
        try {
          this.$refs.videoPlayer.pause();
          this.$refs.videoPlayer.currentTime = 0;
        } catch (e) {}
      }
    }
  }
};
</script>

<style lang="less" scoped>
.video-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-content {
  position: relative;
  width: 80%;
  max-width: 900px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}
.video-content video {
  width: 100%;
  height: auto;
  display: block;
}
.video-close {
  position: absolute;
  right: 10px;
  top: 6px;
  color: #fff;
  font-size: 28px;
  line-height: 28px;
  cursor: pointer;
  z-index: 2;
}
</style>





// WEBPACK FOOTER //
// src/components/comm/VideoModal.vue